export const EvaluationCenterRoutes = [{
  path: '/EvaluationCenter',
  component: () => import('./EvaluationCenter.vue'),
  meta: {
    crumbName: '素质测评',
  },
  children: [
    {
      path: '',
      name: '测评信息',
      component: () => import('../information.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false,
        //页面是否需要缓存
        // keepAlive:true
      }
    }, {
      path: 'detail/:guid?',
      name: '测评信息详情',
      component: () => import('../detail.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false
      }
    }, {
      path: 'applicationList',
      name: '测评机构批量报名清单',
      component: () => import('../applicationList.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false
      }
    }, {
      path: 'certificate',
      name: '证书查询',
      component: () => import('../certificate.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false
      }
    }, {
      path: 'cooperationAgency',
      name: '合作单位',
      component: () => import('../cooperationAgency.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false,
        //页面是否需要缓存
        // keepAlive:true
      }
    },{
      path: 'office',
      name: '湖北省区域办公室',
      component: () => import('../office'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false,
      }
    },{
      path: 'cooperationDetail',
      name: '机构一览详情',
      component: () => import('../cooperationDetail.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false
      }
    }, {
      path: 'download',
      name: '资料下载',
      component: () => import('../download.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/pages/EvaluationCenter/router/EvaluationCenter.routes.js